import React from 'react';
import { useTranslation } from 'react-i18next';

import { isPremierDubai } from 'utils/template';

export default function PickNLinesTitle({ numbersToPick }: Readonly<{ numbersToPick: number }>) {
    const { t } = useTranslation();

    return (
        <h2>
            {t(`playPicker.${isPremierDubai() ? 'chooseNumbers' : 'pickNNumbers'}`, { numbersToPick })}
            <span className="d-block d-sm-inline"> {t('playPicker.oneFromEachLine')}</span>
        </h2>
    );
}
